import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEauth from './eAuth-clients.reducers';
import * as fromSubmitEmail from './submit-email.reducer';
import * as fromCreateStandingAuthEauth from './create-standing-auth-eauth-clients.reducers'

export const setupEAuthorizationFeatureKey = 'setupEAuthorization';

export interface SetupEAuthorizationState {
    [fromEauth.eauthKey]: fromEauth.State;
    [fromCreateStandingAuthEauth.createStandingAuthEauthKey]: fromCreateStandingAuthEauth.State;
    [fromSubmitEmail.submitEmailKey]: fromSubmitEmail.State;
}

export function reducers(
    state: SetupEAuthorizationState | undefined,
    action: Action
) {
    return combineReducers({
        [fromEauth.eauthKey]: fromEauth.eAuthClientsReducer,
        [fromCreateStandingAuthEauth.createStandingAuthEauthKey]: fromCreateStandingAuthEauth.createStandingAuthEauthClientsReducer,
        [fromSubmitEmail.submitEmailKey]: fromSubmitEmail.submitEmailReducer
    })(state, action);
}

export const selectSetupEAuthorization = createFeatureSelector<SetupEAuthorizationState>(
    setupEAuthorizationFeatureKey
);

export const selectEAuthState = createSelector(
    selectSetupEAuthorization,
    (state) => {
        return state.eauth;
    }
)

export const selectEAuthClients = createSelector(
    selectEAuthState,
    (state) => {
        return state.eauthClients;
    }
)

export const selectEauthClientServiceError = createSelector(
    selectEAuthState,
    (state) => {
        return state.hasServiceError;
    }
)

export const selectEauthClientCallSucessfullyCompleted = createSelector(
    selectEAuthState,
    (state) => {
        return state.euthClientCallSuccess;
    }
)

export const selectCreateStandingAuthEAuthState = createSelector(
    selectSetupEAuthorization,
    (state) => {
        return state.createStandingAuthEauth;
    }
)

export const selectCreateStandingAuthEAuthClients = createSelector(
    selectCreateStandingAuthEAuthState,
    (state) => {
        return state.eauthClients;
    }
)

export const selectCreateStandingAuthEauthClientServiceError = createSelector(
    selectCreateStandingAuthEAuthState,
    (state) => {
        return state.hasServiceError;
    }
)

export const selectCreateStandingAuthtEauthClientCallSucessfullyCompleted = createSelector(
    selectCreateStandingAuthEAuthState,
    (state) => {
        return state.eauthClientCallSLOASuccess;
    }
)

export const selectEmailState = createSelector(
    selectSetupEAuthorization,
    (state) => {
        return state.email;
    }
)

export const selectSendEmailErrorState = createSelector(
    selectEmailState,
    (state) => {
        return state.hasSendEmailError;
    }
)

export const selectSubmitEmail = createSelector(
    selectEmailState,
    (state) => {
        return state.isEmailSubmitted;
    }
)

export const selectSubmittedEmailCustomerId = createSelector(
    selectEmailState,
    (state) => {
        return state.customerId;
    }
)

export const selectEauthMissingEmail = createSelector(
    selectEAuthClients,
    selectSubmittedEmailCustomerId,
    (clients, submitted) => {
        return clients.eauthClients.some(customer => customer.eauthSetup.status === 'Email required' && submitted !== customer.customerId);
    }
)